import React from "react";
import { refreshAccessToken } from "../api/oauthAPI";
import { deleteDelegateData } from "../api/DelegateAPI";
import { retrieveFirmContactData, retrieveFirmContactDataByTaxId } from "../api/DelegateAPI"


export default function FCDelete(props) {
   
    const dlgtEid = props.fcDisplayResponse.eid
    const firmEid = props.fcResponse[0].eid
    const dpEid = firmEid.substring(0,9)
    let firmName = 'unknown'
    let fcName
    
    if (props.fcResponse[0].name) {
    firmName = props.fcResponse[0].name.lastName
    }
    
    if(props.fcDisplayResponse.name !== null && props.fcDisplayResponse.name !== undefined) {
    fcName = props.fcDisplayResponse.name.firstName + ' ' + props.fcDisplayResponse.name.middleName + ' ' + props.fcDisplayResponse.name.lastName + ' ' + props.fcDisplayResponse.name.suffix
    }

    return (
        <div>

            <h3>Delete Firm Contact</h3>


            Are you sure you want to delete {fcName} as a Firm Contact for {firmName}?
            <br></br>
            <br></br>
            <button
                className="pds-button pds-button-primary"
                data-gtm="modal-cta"
                id ="submitDeleteFirmContactButton"
                onClick={submitFirmContactDelete}  
                >
                Yes, Delete
            </button>
            &nbsp;
            <button
                className="pds-button pds-button-secondary"
                data-gtm="modal-cta"
                id ="firmFcListButton"
                onClick={returnToFcList}  
                >
                Cancel
            </button>
        </div>
    )
    function isNumber(num) {
        return !isNaN(parseFloat(num)) && isFinite(num);
    }
    function returnToFcList() {
        props.setFcDeleteMode(false)
    }
    
    async function submitFirmContactDelete() {
        props.setSpinnerActive(true)
        let token = props.user.access_token
        document.getElementById("submitDeleteFirmContactButton").disabled=true

        if (props.user.expired) {
        token = await refreshAccessToken(props.user.refresh_token)
        }
        
        if(dlgtEid !== null && dlgtEid !== undefined && dpEid !== null && dpEid !== undefined) {
            props.setFcDeleteMode(true)
            let response = null;       
            response = await deleteDelegateData(
                token,
                dpEid,
                dlgtEid,
                props.userEid
            );
               
            let resp = null;
            if(isNumber(props.searchValue)){
                resp= await retrieveFirmContactDataByTaxId(token, props.searchValue)
            } else {
                resp= await retrieveFirmContactData(token, props.searchValue)
            }
            
            if (resp.responseBody) {
                props.setfcResponse(resp.responseBody)
            } else {
                props.setfcResponse(null)
            }

            if ((response != null) && (response === 200 || response === 204)) {
                props.setSpinnerActive(false)
                props.setFcDisplayResponse(null)
                
                props.setFcDeleteMode(false)
                props.setGlobalAlert(
                    {
                      id: "success-delete",
                      type: "success",
                      message:
                        "Firm Contact Deleted ",
                      hidden: false,
                    }
                  )
            } else {
                props.setSpinnerActive(false)
                props.setFcDisplayResponse(null)
                
                props.setFcDeleteMode(false)
                props.setGlobalAlert(
                    {
                      id: "error-delete",
                      type: "error",
                      message:
                        "Firm Contact delete failed",
                      hidden: false,
                    }
                  )
            }
        }
    }
}